/**
 * Sentinel stored on HRBP grants (`moduleAccess: ['all']`) — must match backend `HRBP_MODULE_ACCESS_ALL`.
 */
export const HRBP_MODULE_ACCESS_ALL = 'all';

/** @deprecated Use {@link HRBP_MODULE_CODE_PULSE} */
export const HRBP_ROUTE_MODULE_PULSE = 'pulse';

export const HRBP_MODULE_CODE_PULSE = 'pulse';
export const HRBP_MODULE_CODE_PERFORMANCE = 'performance';
/** 1:1s / One-on-ones — stored as `oneon1s` in grants */
export const HRBP_MODULE_CODE_ONEON1S = 'oneon1s';
export const HRBP_MODULE_CODE_CALIBRATION = 'calibration';
export const HRBP_MODULE_CODE_GOALS = 'goals';
export const HRBP_MODULE_CODE_DEVELOPMENT = 'development';
export const HRBP_MODULE_CODE_RECOGNITION = 'recognition';
export const HRBP_MODULE_CODE_CAREER = 'career';
export const HRBP_MODULE_CODE_ORGANIGRAM = 'organigram';
export const HRBP_MODULE_CODE_ONBOARDING = 'onboarding';

/**
 * Canonical module codes for HRBP grants (organigram multi-select). Order = UI order.
 * Must stay aligned with `organigram.roles-assignment.hrbp-module-*` i18n keys (`-${code}`).
 */
export const HRBP_SELECTABLE_MODULE_CODES = [
  HRBP_MODULE_CODE_PULSE,
  HRBP_MODULE_CODE_PERFORMANCE,
  HRBP_MODULE_CODE_ONEON1S,
  HRBP_MODULE_CODE_CALIBRATION,
  HRBP_MODULE_CODE_GOALS,
  HRBP_MODULE_CODE_DEVELOPMENT,
  HRBP_MODULE_CODE_RECOGNITION,
  HRBP_MODULE_CODE_CAREER,
  HRBP_MODULE_CODE_ORGANIGRAM,
  HRBP_MODULE_CODE_ONBOARDING,
] as const;

export type HrbpSelectableModuleCode = (typeof HRBP_SELECTABLE_MODULE_CODES)[number];
